import { render, staticRenderFns } from "./index-item.vue?vue&type=template&id=2db153e6&scoped=true&"
import script from "./index-item.vue?vue&type=script&lang=js&"
export * from "./index-item.vue?vue&type=script&lang=js&"
import style0 from "./index-item.vue?vue&type=style&index=0&id=2db153e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db153e6",
  null
  
)

export default component.exports